import {
  BasketColumn,
  BasketColumnKeys,
} from 'graphql-api/baskets-api-interfaces';

export const filterColumnsByShowWholeSalesPrice =
  (showWholeSalePrices: boolean) =>
  (columns: BasketColumn[]): BasketColumn[] => {
    if (showWholeSalePrices) {
      return columns;
    }

    return columns
      .filter(
        (column) =>
          ![BasketColumnKeys.Wsp, BasketColumnKeys.Markup].includes(column.key),
      )
      .map((column) => {
        if ([BasketColumnKeys.Value].includes(column.key)) {
          return { ...column, key: BasketColumnKeys.ValueRrp };
        }

        if ([BasketColumnKeys.Discount].includes(column.key)) {
          return { ...column, key: BasketColumnKeys.DiscountRrp };
        }

        return column;
      });
  };
